import IntlMessageFormat from 'intl-messageformat';

function labelMaker(translation = '', args) {
    let formattedMessage = '';
    let valueMap = args;
    let i = 0;

    if (Array.isArray(args) && args.length) {
        if (args.length === 1 && typeof args[0] === 'object') {
            valueMap = args[0];
        } else {
            valueMap = {};
            for (i; i < args.length; i++) {
                valueMap[i] = args[i];
            }
        }
    } else {
        return translation;
    }

    let intlMessageFormat = new IntlMessageFormat(translation);
    formattedMessage = intlMessageFormat.format(valueMap);

    return formattedMessage;
}

function translate(translations, namespace, bundle, key = '', ...args) {
    let translation = `???${key}???`;

    try {
        translation = translations[namespace][bundle][key];

        if (Array.isArray(args) && args.length) {
            translation = labelMaker(translation, args);
        }
    } catch (e) {
        // TODO: think of a smart way to catch these
        // eslint-disable-next-line no-console
        console.warn(`${key} not found in ${namespace}/${bundle}`);
    }

    return translation;
}

export default translate;
